import { takeLatest, put, call, select } from 'redux-saga/effects';
import { axiosInstance } from '../../utils';

import { CHECK_PROMO_CODE_REQUEST, CHECK_PROMO_CODE_SUCCESS, CHECK_PROMO_CODE_FAILURE, UPDATE_USER_PRODUCT_REMOVE_PROMO, ADD_CREDIT_REQUEST  } from "../types";

function* promoSaga({ payload }) {
  const code = payload;
  const productPrice = yield select(state => state.userProduct.product.price);
  const prevPromoStatus = yield select(state => state.promo.status);
  const userData = yield select(state => state.user.userData);
  const userGuest = yield select(state => state.userPreferences.guests);
  const productMaxGuests = yield select(state => state.userProduct.product.maxGuests);
  const isDoubled = Number(productPrice.oldPrice) !== Number(productPrice.newPrice);

  try {
    const { data } = yield call(axiosInstance.post, 'payment/promo', { promo: code, userId: userData && userData.userId });

    if (isDoubled) {
      yield put({ type: UPDATE_USER_PRODUCT_REMOVE_PROMO, payload: { ...productPrice, newPrice: productPrice.oldPrice, discountName: '', total: productPrice.oldTotal  } });
    }
    if (data.type === 1 && !data.isPromo ) {
      yield put({ type: ADD_CREDIT_REQUEST, payload: { promoCode: code, source: 'checkout' } });
    } else {
      const prodAmount = Math.ceil(userGuest/productMaxGuests);

      if (!data.isEgift && data.minAmount > productPrice.newPrice * prodAmount) {
        yield put({ type: CHECK_PROMO_CODE_FAILURE, payload: `Min amount ($${data.minAmount.toFixed(2)}) is not met, code will not apply` });
      } else {
        yield put({ type: CHECK_PROMO_CODE_SUCCESS, payload: { info: { code, ...data, isDouble: prevPromoStatus !== 'initial' || isDoubled } } });
      }
    }

  } catch (error) {
    yield put({ type: CHECK_PROMO_CODE_FAILURE, payload: error });
  }
}

export default function* saga() {
  yield takeLatest(CHECK_PROMO_CODE_REQUEST, promoSaga);
}
